import { FormDropdown, FormTextArea } from 'components/shared/Forms/ReduxForm'
import config from 'config/config'

import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { arrayPush, arrayRemove, change, Field, formValues } from 'redux-form'
import { Button, Comment, Grid, Icon } from 'semantic-ui-react'

const i18nkey = 'admin.todo.'

const mapStateToProps = (state, ownProps) => {
  const { users } = state.userAdmin
  return { users }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      arrayPush,
      arrayRemove,
      change,
    },
    dispatch
  )
}

class ProductToDos extends React.Component {
  addTodo() {
    const { arrayPush, new_todo_text, new_todo_user_id, form } = this.props
    const { change } = this.props
    if (!new_todo_text) return
    arrayPush(form, 'toDos', { user_id: new_todo_user_id, text: new_todo_text })
    change(form, 'new_todo_text', null)
  }

  deleteTodo(index) {
    const { arrayRemove, form } = this.props
    arrayRemove(form, 'toDos', index)
  }

  // TODO: add default icon
  // TODO: add something to delete todo.
  toDoList() {
    const allowDelete = false
    const { users } = this.props
    const toDos =
      this.props.toDos && users.length > 0
        ? this.props.toDos.map((toDo) => ({
            text: toDo.text,
            user: users.find((user) => user.id === toDo.user_id),
            done: toDo.done,
          }))
        : []

    return toDos.map((toDo, index) => (
      <Comment key={index}>
        <Comment.Avatar
          src={toDo.user.avatar && config.api_url + toDo.user.avatar.thumb_url}
        />
        <Comment.Content>
          <Comment.Author children={toDo.user.name} />
          <Comment.Text>
            {toDo.done && <Icon name="check" color="green" />}
            {toDo.text}
          </Comment.Text>
          {allowDelete && (
            <Comment.Actions>
              <Comment.Action
                children={I18n.t(i18nkey + 'remove')}
                onClick={(index) => {
                  this.deleteTodo(index)
                }}
              />
            </Comment.Actions>
          )}
        </Comment.Content>
      </Comment>
    ))
  }

  render() {
    const { users } = this.props

    const userDropdownProps = {
      component: FormDropdown,
      name: 'new_todo_user_id',
      label: I18n.t(i18nkey + 'for_user'),
      options: users
        .filter(
          (user) => user.user_type === 'admin' || user.user_type === 'user'
        )
        .map((user) => ({ text: user.email, value: user.id })),
    }

    const inputProps = {
      component: FormTextArea,
      label: I18n.t(i18nkey + 'text'),
      name: 'new_todo_text',
    }

    const buttonProps = {
      content: I18n.t(i18nkey + 'add'),
      labelPosition: 'left',
      icon: 'plus',
      onClick: (event) => {
        event.preventDefault()
        this.addTodo()
      },
    }

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={12}>
            <Comment.Group children={this.toDoList()} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={8}>
            <Field {...inputProps} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row verticalAlign="bottom">
          <Grid.Column width={2}>
            <Field {...userDropdownProps} fluid search selection />
          </Grid.Column>
          <Grid.Column width={2}>
            <Button {...buttonProps} fluid primary />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

ProductToDos = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductToDos)
ProductToDos = formValues('toDos', 'new_todo_text', 'new_todo_user_id')(
  ProductToDos
)
export default ProductToDos



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductToDos.jsx